import React from 'react';
import PostForm from './PostForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';

const PostModal = ({ modalOpen, handleCloseWizard }) => {
  return (
    <StandardModal
      isOpen={modalOpen}
      onRequestClose={handleCloseWizard}
    >
      <PostForm handleCloseWizard={handleCloseWizard}/>
    </StandardModal>
  );
};


export default PostModal;
